import { gateway } from "src/gateway";
import { SuperAdminUsersResponse, SuperAdminUsersResult } from "../interfaces";

interface GetSuperAdminUsersParams {
  page?: number;
  pageSize?: number;
  search?: string;
  role?: string;
  confirmationStatus?: string;
  recordType?: string;
}

export const getSuperAdminUsers = async ({
  page = 1,
  pageSize = 20,
  search = "",
  role = "all",
  confirmationStatus = "all",
  recordType = "all",
}: GetSuperAdminUsersParams = {}): Promise<SuperAdminUsersResult> => {
  const response = await gateway.get<SuperAdminUsersResponse>("/users/super-admin", {
    params: {
      page,
      pageSize,
      search: search.trim() || undefined,
      role: role === "all" ? undefined : role,
      confirmationStatus: confirmationStatus === "all" ? undefined : confirmationStatus,
      recordType,
    },
  });

  return response.data.data;
};
